import { createApp } from 'vue'
import App from './App.vue'
import  './CSS/styles.css'
import  './CSS/animations.css'

createApp(App).mount('#app')
